import { method } from "lodash";
import { apiSlice } from "./apiSlice";

const downloadFile = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
};

export const adminApi = apiSlice.injectEndpoints({
    keepUnusedDataFor: 1,
    endpoints: (builder) => ({
        getAdminSettings: builder.query({
            query: (params) => ({
                url: `/admin-panel/setting`,
                method: "GET",
                params,
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        updateAdminSettings: builder.mutation({
            query: (payload) => ({
                url: `/admin-panel/setting`,
                method: "PUT",
                body: { ...payload },
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        ///* *** NOT WORKING  *** */
        updateProofOfDeliveryByAdmin: builder.mutation({
            query: ({ merchantId, payload }) => ({
                url: `/admin-panel/merchant/proofOfDelivery/${merchantId}`,
                method: "PUT",
                body: { ...payload },
            }),
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        ///* *** NOT WORKING  *** */
        updateSalla: builder.mutation({
            query: ({ merchantId, payload }) => ({
                url: `/admin-panel/merchant/update-salla/${merchantId}`,
                method: "PUT",
                body: { ...payload },
            }),
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        getMerchantProfileByAdmin: builder.query({
            query: (id) => {
                return {
                    url: `/admin-panel/merchant/${id}`,
                    method: "GET",
                };
            },
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        getMerchantCommercailDataByAdmin: builder.query({
            query: (id) => {
                return {
                    url: `/admin-panel/merchant/${id}/commercial-profile`,
                    method: "GET",
                };
            },
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        getDriverByAdmin: builder.query({
            query: (id) => {
                return {
                    url: `/admin-panel/driver/${id}`,
                    method: "GET",
                };
            },
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        updateMerchantProfileByAdmin: builder.mutation({
            query: ({ merchantId, payload }) => {
                return {
                    url: `/admin-panel/merchant/${merchantId}`,
                    method: "PUT",
                    body: { ...payload },
                };
            },
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        updateMerchantProfileBasicInfoByAdmin: builder.mutation({
            query: ({ id, payload }) => {
                return {
                    url: `/admin-panel/merchant/${id}/commercial-profile`,
                    method: "PATCH",
                    body: { ...payload },
                };
            },
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        updateFreelanceDriverProfileByAdmin: builder.mutation({
            query: ({ id, payload }) => {
                return {
                    url: `/admin-panel/driver/${id}`,
                    method: "PUT",
                    body: { ...payload },
                };
            },
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        updateMerchantStatus: builder.mutation({
            query: ({ merchantId, payload }) => {
                return {
                    url: `/admin-panel/merchant/update-status/${merchantId}`,
                    method: "PUT",
                    body: { ...payload },
                };
            },
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        updateMerchantPasswordByAdmin: builder.mutation({
            query: ({ merchantId, payload }) => {
                return {
                    url: `/admin-panel/merchant/update-password/${merchantId}`,
                    method: "PUT",
                    body: { ...payload },
                };
            },
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        updateFreelanceDriverPasswordByAdmin: builder.mutation({
            query: ({ driverId, payload }) => {
                return {
                    url: `/admin-panel/driver/update-password/${driverId}`,
                    method: "PUT",
                    body: { ...payload },
                };
            },
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        deleteMerchantByAdmin: builder.mutation({
            query: (merchantId) => {
                return {
                    url: `/admin-panel/merchant/${merchantId}`,
                    method: "DELETE",
                };
            },
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        getMerchants: builder.query({
            query: (params) => {
                return {
                    url: `/admin-panel/merchant`,
                    method: "GET",
                    params,
                };
            },
            providesTags: ["MERCHANT"],
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        // Lightweight paginated list ({ id, companyName } only) for merchant selects/autocompletes.
        // Params: page, limit, searchKey, ids (csv), deliveryMethod, role
        getMerchantsSearch: builder.query({
            query: (params) => {
                return {
                    url: `/admin-panel/merchant/search-new`,
                    method: "GET",
                    params,
                };
            },
            providesTags: ["MERCHANT"],
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        exportMerchantsData: builder.mutation({
            query: (payload) => {
                return {
                    url: `/admin-panel/merchant/xls`,
                    method: "POST",
                    body: { ...payload },
                };
            },
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        exportMerchantById: builder.query({
            query: (id) => ({
                url: `/admin-panel/merchant/${id}/xls`,
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Accept:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                },
                responseHandler: (response) => response.blob(),
            }),
            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled;
                    downloadFile(data, "merchant_data.xlsx");
                } catch (error) {
                    console.error("Download failed", error);
                }
            },
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        getMapitShipMerchants: builder.query({
            query: (params) => {
                return {
                    url: `/admin-panel/merchant/mapit-ship`,
                    method: "GET",
                    params,
                };
            },

            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        createMerchant: builder.mutation({
            query: (payload) => {
                return {
                    url: `/admin-panel/merchant`,
                    method: "POST",
                    body: { ...payload },
                };
            },
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        createUserForDemo: builder.mutation({
            query: (payload) => {
                return {
                    url: `/admin-panel/merchant/no-password`,
                    method: "POST",
                    body: { ...payload },
                };
            },
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        encouragementEmail: builder.mutation({
            query: (payload) => {
                return {
                    url: `/admin-panel/merchant/encouragement-email`,
                    method: "POST",
                    body: { ...payload },
                };
            },
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),

        //////////////////* Endpoint to get inactive merchant and negative balances *  */////////////////////////// 
        getInactiveMerchantList: builder.query({
            query: (params) => {
                return {
                    url: `/admin-panel/merchant/inactive`,
                    method: "GET",
                    params,
                };
            },
            providesTags: ["INACTIVE"],
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),

        getMerchantNegativeBalanceList: builder.query({
            query: (params) => {
                return {
                    url: `/admin-panel/merchant/negative-balance`,
                    method: "GET",
                    params,
                };
            },
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        createNoteClassification: builder.mutation({
            query: (payload) => ({
                url: `/notes/classification`,
                method: "POST",
                body: { ...payload },
            }),
            invalidatesTags: ["MERCHANT"],
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),

        toApproveOrRejectAMerchantCommercialData: builder.mutation({
            query: ({ id, payload }) => ({
                url: `/admin-panel/merchant/${id}/approve-commercial-data`,
                method: "PUT",
                body: { ...payload },
            }),
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        adminCountApprovelandWaiting: builder.query({
            query: () => ({
                url: `/admin-panel/merchant/counts`,
                method: 'GET'
            }),
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        updateControlSatchelsShipmentCreationDisplayAdmin: builder.mutation({
            query: (body) => ({
                url: `/admin-panel/setting`,
                method: "PUT",
                body
            })
        }),
        getAdminApprovelandWaiting: builder.query({
            query: (params) => ({
                url: `/admin-panel/merchant/needs-approval`,
                method: 'GET',
                params
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) =>
                response?.data?.message ?? "Something went wrong please try again",
        }),
        updateMerchantPriceCategory: builder.mutation({
            query: ({ id, categoryId }) => ({
                url: `/admin-panel/merchant/${id}/pricing-category`,
                method: "PUT",
                body: {
                    categoryId,
                },
            })
        }),
    }),
});

export const {
    useGetAdminSettingsQuery,
    useUpdateAdminSettingsMutation,
    useUpdateProofOfDeliveryByAdminMutation,
    useUpdateSallaMutation,
    useUpdateMerchantStatusMutation,
    useGetMerchantProfileByAdminQuery,
    useGetDriverByAdminQuery,
    useLazyGetDriverByAdminQuery,
    useUpdateMerchantProfileByAdminMutation,
    useUpdateFreelanceDriverProfileByAdminMutation,
    useUpdateMerchantPasswordByAdminMutation,
    useUpdateFreelanceDriverPasswordByAdminMutation,
    useDeleteMerchantByAdminMutation,
    useGetMerchantsQuery,
    useGetMerchantsSearchQuery,
    useExportMerchantsDataMutation,
    useLazyExportMerchantByIdQuery,
    useGetMapitShipMerchantsQuery,
    useCreateMerchantMutation,
    useCreateUserForDemoMutation,
    useEncouragementEmailMutation,
    useGetInactiveMerchantListQuery,
    useGetMerchantNegativeBalanceListQuery,
    useCreateNoteClassificationMutation,
    useToApproveOrRejectAMerchantCommercialDataMutation,
    useUpdateMerchantProfileBasicInfoByAdminMutation,
    useAdminCountApprovelandWaitingQuery,
    useUpdateControlSatchelsShipmentCreationDisplayAdminMutation,
    useGetMerchantCommercailDataByAdminQuery,
    useGetAdminApprovelandWaitingQuery,
    useUpdateMerchantPriceCategoryMutation
} = adminApi;
